import { gql } from '@provision/graphql-client';

export const BACKGROUND_JOB_FIELDS = gql`
  fragment BackgroundJobFields on BackgroundJob {
    jobId
    jobType
    partnerId
    status
    totalItems
    succeededCount
    failedCount
    createdByUserId
    params
    createdAt
    updatedAt
    startedAt
    completedAt
  }
`;

export const GET_BACKGROUND_JOB_QUERY = gql`
  ${BACKGROUND_JOB_FIELDS}
  query GetBackgroundJob($params: GetBackgroundJobInput!) {
    getBackgroundJob(params: $params) {
      ...BackgroundJobFields
    }
  }
`;

export const GET_BACKGROUND_JOB_ITEMS_QUERY = gql`
  query GetBackgroundJobItems($params: GetBackgroundJobItemsInput!) {
    getBackgroundJobItems(params: $params) {
      items {
        itemKey
        status
        attempts
        result
        error {
          code
          message
        }
        startedAt
        finishedAt
      }
      nextToken
    }
  }
`;

export const GET_BACKGROUND_JOBS_QUERY = gql`
  ${BACKGROUND_JOB_FIELDS}
  query GetBackgroundJobs($params: GetBackgroundJobsInput!) {
    getBackgroundJobs(params: $params) {
      items {
        ...BackgroundJobFields
      }
      nextToken
    }
  }
`;
